import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EntitlementsLibModule } from '@unified-ui/entitlements';
import { GlobalLicensesModule } from '@unified-ui/global-licenses';
import { SharedInterceptorModule } from '@unified-ui/interceptors';
import { SharedAuthLibModule } from '@unified-ui/shared/auth-lib';
import { SharedDataStoreModule } from '@unified-ui/shared/data-store';
import { UserFoldersLibModule } from '@unified-ui/user-folders';
import { MessageService } from 'primeng/api';
import { PlatformComponent } from './platform.component';

@NgModule({
    imports: [
        PlatformComponent,
        BrowserAnimationsModule,
        SharedAuthLibModule,
        SharedDataStoreModule,
        EntitlementsLibModule,
        SharedInterceptorModule,
        GlobalLicensesModule,
        UserFoldersLibModule
        // Note: Report tabs feature is registered in main.ts using provideStore
    ],
    providers: [provideHttpClient(withInterceptorsFromDi()), MessageService]
})
export class PlatformModule {}
